import { render, staticRenderFns } from "./StorageOptions.vue?vue&type=template&id=5d8624e0"
import script from "./StorageOptions.vue?vue&type=script&lang=js"
export * from "./StorageOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports